import { render } from "./loan-product-account.vue?vue&type=template&id=57808d34"
import script from "./loan-product-account.vue?vue&type=script&lang=js"
export * from "./loan-product-account.vue?vue&type=script&lang=js"

import "./loan-product-account.vue?vue&type=style&index=0&id=57808d34&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__